import Request from '../Request.utils'
export interface ILoginRequestBody {
  email: string;
  password: string;
}
export interface IRegisterRequestBody {
  companyAddress?: string;
  companyCity?: string;
  companyCode?: string;
  companyCountry?: string;
  companyName?: string;
  companyPhone?: string;
  companyPostcode?: string;
  companySize?: string;
  email: string;
  emailOptIn?: boolean;
  firstName: string;
  industry?: string;
  lastName: string;
  mobile?: string;
  password: string;
  whatsappOptIn?: boolean;
}
export interface IGetUploadPresignedUrlRequestBody {
  contentType: string;
  serverSidePath: string;
}
export interface IListResellersRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface IDetailRequestParams {
  id: string;
}
export interface IUpsertResellerRequestBody {
  accountName?: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  currency?: string;
  email?: string;
  firstName?: string;
  id?: string;
  isAutoAccept?: boolean;
  lastName?: string;
  otherData?: any;
  password?: string;
  photoUrl?: string;
  postCode?: string;
  town?: string;
}
export interface IUpsertResellerUserRequestBody {
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  email?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
  onlineStoreId?: string;
  otherData?: any;
  password?: string;
  photoUrl?: string;
  postCode?: string;
  town?: string;
}
export interface IListResellerUserRequestQuery {
  page?: number;
}
export interface IDetailResellerUserRequestParams {
  id: string;
}
export interface IUpdateProfileRequestBody {
  accountName?: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  defaultLocationId?: string;
  firstName?: string;
  isAutoAccept?: '';
  lastName?: string;
  notificationPreferences?: object | '';
  password?: string;
  photoUrl?: string;
  postCode?: string;
  town?: string;
}
export interface IChangePasswordRequestBody {
  currentPassword: string;
  newPassword: string;
}
export interface ICheckAutoAcceptOrderRequestParams {
  id: string;
}
export interface IDeleteResellerRequestParams {
  id: string;
}
export interface ICheckInviteCodeRequestBody {
  code: string;
  email: string;
  firstName?: string;
  lastName?: string;
  password: string;
}
export interface ICheckImageQualityRequestBody {
  callbackUrl?: string;
  urls?: string[];
}
export interface IForgotPasswordRequestBody {
  email: string;
}
export interface IResetPasswordRequestBody {
  code: string;
  newPassword: string;
}
export interface IVerifyForgotPasswordRequestBody {
  code: string;
}
export interface IGetResellerWalletBalanceRequestParams {
  resellerId: string;
}
export interface IGetUserEditorImagesRequestParams {
  userId: string;
}
export interface ISetUserEditorImagesRequestBody {
  images: string[];
}
export interface ISetUserEditorImagesRequestParams {
  userId: string;
}
export interface IGenerateShareTokenRequestBody {
  customer: object;
  customerId?: string;
  shop?: string;
}
export interface IValidateShareTokenRequestQuery {
  token: string;
}
export interface IShopifyLoginCallbackRequestBody {
  shopId: string;
  tokenData: {
    access_token: string;
    expires_in?: number;
    id_token: string;
    refresh_token?: string;
    token_type?: string;
  };
}
export interface IVerifyRegisterRequestBody {
  email: string;
  verifyCode: string;
}
export interface IListPendingReviewRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface IApproveRegistrationRequestBody {
  action: 'approve' | 'reject';
  userId: string;
}
export interface IResendActivationRequestBody {
  userId: string;
}
export interface IActivateRequestBody {
  registrationData?: {
    companyAddress?: string;
    companyCity?: string;
    companyCountry?: string;
    companyPhone?: string;
    companyPostcode?: string;
    mobile?: string;
  };
  token: string;
}
export interface IInviteUserRequestBody {
  approvalCategories?: {
    bulkOrders?: boolean;
    creditsReplacements?: boolean;
    specialRequests?: boolean;
    standardOrders?: boolean;
  };
  customMessage?: string;
  email: string;
  emailNotif?: boolean;
  enableApprover?: boolean;
  firstName: string;
  hidePricing?: boolean;
  lastName?: string;
  maxAmount?: number | null | '';
  minAmount?: number | null | '';
  mobile?: string;
  notifyAdmin?: boolean;
  requirePasswordChange?: boolean;
  role: 'customer-admin' | 'area-manager' | 'site-level' | 'global-admin';
  selectedSites?: string[];
  sendInvite?: boolean;
  whatsappNotif?: boolean;
}
export interface IInviteLookupRequestQuery {
  companyId?: string;
  email: string;
}
export interface IAcceptInviteRequestBody {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  password: string;
  token: string;
}
export interface IResendInviteLinkRequestBody {
  customMessage?: string;
  email: string;
}
export interface IAssignUserLocationsRequestBody {
  locationExternalIds: string[];
  userId: string;
}
export interface IAssignUserLocationsStatusRequestQuery {
  jobId: string;
}
export interface IUnassignUserLocationRequestBody {
  locationExternalId: string;
  userId: string;
}
export interface IBulkInviteExistingUsersRequestBody {
  emails: string[];
  role?: 'customer-admin' | 'area-manager' | 'site-level';
}
export interface IBulkInviteStatusRequestParams {
  jobId: string;
}
export interface IInviteTokenInfoRequestParams {
  token: string;
}
export interface ITestNotificationRequestBody {
  type: 'order-confirmed' | 'out-for-delivery' | 'eta-update' | 'next-stop' | 'delivered' | 'issue-response' | 'backorder-update' | 'substitution-offered' | 'driver-rating';
}
export interface ITestWhatsAppSendRequestBody {
  message?: string;
  phone: string;
}
export interface IListNotificationsRequestQuery {
  page?: number;
  pageSize?: number;
  read?: boolean;
}
export interface IMarkNotificationReadRequestParams {
  id: string;
}
export interface IListUsersRequestQuery {
  page?: number;
  pageSize?: number;
  role?: '' | 'all' | 'global-admin' | 'customer-admin' | 'area-manager' | 'site-level';
  search?: string;
}
export interface IUpdateUserRequestBody {
  accountName?: string;
  capabilities?: string[];
  companyId?: string;
  companyName?: string;
  email?: string;
  firstName?: string;
  isApprover?: boolean;
  lastName?: string;
  mobile?: string;
  photoUrl?: string;
  role?: 'admin' | 'user' | 'reseller' | 'customer-admin' | 'area-manager' | 'site-level' | 'global-admin' | 'unverified' | 'pending_review' | '';
}
export interface IUpdateUserRequestParams {
  id: string;
}
export interface IAdminResetPasswordRequestBody {
  newPassword: string;
}
export interface IAdminResetPasswordRequestParams {
  id: string;
}
export interface IResendInviteRequestBody {
  customMessage?: string;
}
export interface IResendInviteRequestParams {
  id: string;
}


class UserAPI {
  login = async (body: ILoginRequestBody) => {
    const res = await Request.call('/api/users/login', 'POST', undefined, undefined, body, );
    if (res.data.data && res.data.data.token) Request.setToken(res.data.data.token)
    return res;
  }
  logout = async () => {
    const res = await Request.call('/api/users/logout', 'POST', undefined, undefined, undefined, );
    Request.setToken('')
    return res;
  }
  register = async (body: IRegisterRequestBody) => {
    const res = await Request.call('/api/users/register', 'POST', undefined, undefined, body, );
    return res;
  }
  me = async () => {
    const res = await Request.call('/api/users/me', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getUploadPresignedUrl = async (body: IGetUploadPresignedUrlRequestBody) => {
    const res = await Request.call('/api/users/me/get-upload-url', 'POST', undefined, undefined, body, );
    return res;
  }
  listResellers = async (query: IListResellersRequestQuery) => {
    const res = await Request.call('/api/users/resellers', 'GET', undefined, query, undefined, );
    return res;
  }
  detail = async (params: IDetailRequestParams) => {
    const res = await Request.call('/api/users/:id', 'GET', params, undefined, undefined, );
    return res;
  }
  upsertReseller = async (body: IUpsertResellerRequestBody) => {
    const res = await Request.call('/api/users/resellers', 'POST', undefined, undefined, body, );
    return res;
  }
  upsertResellerUser = async (body: IUpsertResellerUserRequestBody) => {
    const res = await Request.call('/api/users/resellers-user', 'POST', undefined, undefined, body, );
    return res;
  }
  listResellerUser = async (query: IListResellerUserRequestQuery) => {
    const res = await Request.call('/api/users/resellers-user', 'GET', undefined, query, undefined, );
    return res;
  }
  detailResellerUser = async (params: IDetailResellerUserRequestParams) => {
    const res = await Request.call('/api/users-reseller/:id', 'GET', params, undefined, undefined, );
    return res;
  }
  updateProfile = async (body: IUpdateProfileRequestBody) => {
    const res = await Request.call('/api/users/me/profile', 'POST', undefined, undefined, body, );
    return res;
  }
  changePassword = async (body: IChangePasswordRequestBody) => {
    const res = await Request.call('/api/users/me/change-password', 'POST', undefined, undefined, body, );
    return res;
  }
  checkAutoAcceptOrder = async (params: ICheckAutoAcceptOrderRequestParams) => {
    const res = await Request.call('/api/reseller/:id/check-auto-accept', 'GET', params, undefined, undefined, );
    return res;
  }
  deleteReseller = async (params: IDeleteResellerRequestParams) => {
    const res = await Request.call('/api/users/:id', 'DELETE', params, undefined, undefined, );
    return res;
  }
  checkInviteCode = async (body: ICheckInviteCodeRequestBody) => {
    const res = await Request.call('/api/users/check-invite-code', 'POST', undefined, undefined, body, );
    return res;
  }
  checkImageQuality = async (body: ICheckImageQualityRequestBody) => {
    const res = await Request.call('/api/users/me/check-image-quality', 'POST', undefined, undefined, body, );
    return res;
  }
  forgotPassword = async (body: IForgotPasswordRequestBody) => {
    const res = await Request.call('/api/users/forgot-password', 'POST', undefined, undefined, body, );
    return res;
  }
  resetPassword = async (body: IResetPasswordRequestBody) => {
    const res = await Request.call('/api/users/reset-password', 'POST', undefined, undefined, body, );
    return res;
  }
  verifyForgotPassword = async (body: IVerifyForgotPasswordRequestBody) => {
    const res = await Request.call('/api/users/verify-forgot-password', 'POST', undefined, undefined, body, );
    return res;
  }
  getResellerSampleToken = async () => {
    const res = await Request.call('/api/users/reseller/sample-token', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getResellerWalletBalance = async (params: IGetResellerWalletBalanceRequestParams) => {
    const res = await Request.call('/api/users/:resellerId/wallet-balance', 'GET', params, undefined, undefined, );
    return res;
  }
  getUserEditorImages = async (params: IGetUserEditorImagesRequestParams) => {
    const res = await Request.call('/api/users/:userId/editor-images', 'GET', params, undefined, undefined, );
    return res;
  }
  setUserEditorImages = async (params: ISetUserEditorImagesRequestParams, body: ISetUserEditorImagesRequestBody) => {
    const res = await Request.call('/api/users/:userId/editor-images', 'POST', params, undefined, body, );
    return res;
  }
  isResellerCompleteSetup = async () => {
    const res = await Request.call('/api/users/is-reseller-complete-setup', 'GET', undefined, undefined, undefined, );
    return res;
  }
  sendEmailWithDesktopLink = async () => {
    const res = await Request.call('/api/users/send-email-with-desktop-link', 'POST', undefined, undefined, undefined, );
    return res;
  }
  generateShareToken = async (body: IGenerateShareTokenRequestBody) => {
    const res = await Request.call('/api/users/generate-share-token', 'POST', undefined, undefined, body, );
    return res;
  }
  validateShareToken = async (query: IValidateShareTokenRequestQuery) => {
    const res = await Request.call('/api/users/validate-share-token', 'GET', undefined, query, undefined, );
    return res;
  }
  shopifyLoginCallback = async (body: IShopifyLoginCallbackRequestBody) => {
    const res = await Request.call('/api/users/shopify-login-callback', 'POST', undefined, undefined, body, );
    if (res.data.data && res.data.data.token) Request.setToken(res.data.data.token)
    return res;
  }
  verifyRegister = async (body: IVerifyRegisterRequestBody) => {
    const res = await Request.call('/api/users/verify-register', 'POST', undefined, undefined, body, );
    if (res.data.data && res.data.data.token) Request.setToken(res.data.data.token)
    return res;
  }
  listPendingReview = async (query: IListPendingReviewRequestQuery) => {
    const res = await Request.call('/api/users/pending-review', 'GET', undefined, query, undefined, );
    return res;
  }
  approveRegistration = async (body: IApproveRegistrationRequestBody) => {
    const res = await Request.call('/api/users/approve-registration', 'POST', undefined, undefined, body, );
    return res;
  }
  resendActivation = async (body: IResendActivationRequestBody) => {
    const res = await Request.call('/api/users/resend-activation', 'POST', undefined, undefined, body, );
    return res;
  }
  activate = async (body: IActivateRequestBody) => {
    const res = await Request.call('/api/users/activate', 'POST', undefined, undefined, body, );
    if (res.data.data && res.data.data.token) Request.setToken(res.data.data.token)
    return res;
  }
  inviteUser = async (body: IInviteUserRequestBody) => {
    const res = await Request.call('/api/users/invite-user', 'POST', undefined, undefined, body, );
    return res;
  }
  inviteLookup = async (query: IInviteLookupRequestQuery) => {
    const res = await Request.call('/api/users/invite-lookup', 'GET', undefined, query, undefined, );
    return res;
  }
  acceptInvite = async (body: IAcceptInviteRequestBody) => {
    const res = await Request.call('/api/users/accept-invite', 'POST', undefined, undefined, body, );
    if (res.data.data && res.data.data.token) Request.setToken(res.data.data.token)
    return res;
  }
  resendInviteLink = async (body: IResendInviteLinkRequestBody) => {
    const res = await Request.call('/api/users/resend-invite-link', 'POST', undefined, undefined, body, );
    return res;
  }
  assignUserLocations = async (body: IAssignUserLocationsRequestBody) => {
    const res = await Request.call('/api/users/assign-locations', 'POST', undefined, undefined, body, );
    return res;
  }
  assignUserLocationsStatus = async (query: IAssignUserLocationsStatusRequestQuery) => {
    const res = await Request.call('/api/users/assign-locations/status', 'GET', undefined, query, undefined, );
    return res;
  }
  unassignUserLocation = async (body: IUnassignUserLocationRequestBody) => {
    const res = await Request.call('/api/users/unassign-location', 'POST', undefined, undefined, body, );
    return res;
  }
  bulkInviteExistingUsers = async (body: IBulkInviteExistingUsersRequestBody) => {
    const res = await Request.call('/api/users/bulk-invite-existing-users', 'POST', undefined, undefined, body, );
    return res;
  }
  bulkInviteStatus = async (params: IBulkInviteStatusRequestParams) => {
    const res = await Request.call('/api/users/bulk-invite-status/:jobId', 'GET', params, undefined, undefined, );
    return res;
  }
  inviteTokenInfo = async (params: IInviteTokenInfoRequestParams) => {
    const res = await Request.call('/api/users/invite-token-info/:token', 'GET', params, undefined, undefined, );
    return res;
  }
  testNotification = async (body: ITestNotificationRequestBody) => {
    const res = await Request.call('/api/users/me/test-notification', 'POST', undefined, undefined, body, );
    return res;
  }
  testWhatsAppSend = async (body: ITestWhatsAppSendRequestBody) => {
    const res = await Request.call('/api/users/me/test-whatsapp', 'POST', undefined, undefined, body, );
    return res;
  }
  checkWhatsAppStatus = async () => {
    const res = await Request.call('/api/users/me/whatsapp-status', 'GET', undefined, undefined, undefined, );
    return res;
  }
  listNotifications = async (query: IListNotificationsRequestQuery) => {
    const res = await Request.call('/api/users/me/notifications', 'GET', undefined, query, undefined, );
    return res;
  }
  markNotificationRead = async (params: IMarkNotificationReadRequestParams) => {
    const res = await Request.call('/api/users/me/notifications/:id/read', 'POST', params, undefined, undefined, );
    return res;
  }
  markAllNotificationsRead = async () => {
    const res = await Request.call('/api/users/me/notifications/read-all', 'POST', undefined, undefined, undefined, );
    return res;
  }
  listUsers = async (query: IListUsersRequestQuery) => {
    const res = await Request.call('/api/users/list', 'GET', undefined, query, undefined, );
    return res;
  }
  updateUser = async (params: IUpdateUserRequestParams, body: IUpdateUserRequestBody) => {
    const res = await Request.call('/api/users/:id', 'PUT', params, undefined, body, );
    return res;
  }
  adminResetPassword = async (params: IAdminResetPasswordRequestParams, body: IAdminResetPasswordRequestBody) => {
    const res = await Request.call('/api/users/:id/reset-password', 'POST', params, undefined, body, );
    return res;
  }
  resendInvite = async (params: IResendInviteRequestParams, body: IResendInviteRequestBody) => {
    const res = await Request.call('/api/users/:id/resend-invite', 'POST', params, undefined, body, );
    return res;
  }
}
export default new UserAPI()